import { render } from "./FeedbackEditor.vue?vue&type=template&id=04231029&scoped=true"
import script from "./FeedbackEditor.vue?vue&type=script&lang=js"
export * from "./FeedbackEditor.vue?vue&type=script&lang=js"

import "./FeedbackEditor.vue?vue&type=style&index=0&id=04231029&scoped=true&lang=css"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04231029"]])

export default __exports__